import { render, staticRenderFns } from "./confirmation-submit-modal.vue?vue&type=template&id=15ba5d2d&scoped=true"
import script from "./confirmation-submit-modal.vue?vue&type=script&lang=js"
export * from "./confirmation-submit-modal.vue?vue&type=script&lang=js"
import style0 from "./confirmation-submit-modal.vue?vue&type=style&index=0&id=15ba5d2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ba5d2d",
  null
  
)

export default component.exports